import axios from "axios"
import store from "../stores/store"

// Setup values needed for dollar comparisions to find prepaid freight qualification
const initializeCartVendor = (cart)=>{
  const cartTotal = parseFloat(cart.details.cart_total)
  const vendor = cart.dropshipVendor
  const vendorMin = _.find(vendor.details.vendor_mins, {minFunction: 'order'}).minValue || null
  const vendorPrePaid = _.find(vendor.details.vendor_mins, {minFunction: 'prepaid'}).minValue || null
  return {cartTotal, vendor, vendorMin, vendorPrePaid}
}

// Get full dropship listing of mfg's
export const getMfgList = ()=>{
  return axios.get('/api/v1/private/dropship/mfg_list').catch(error=>{console.error("Error:", error)})
}

// Get associated products for given dropship mfg
export const getMfgProducts = (mfg)=>{
  const params = {vendor_id: mfg.vendor_id}
  return axios.get('/api/v1/private/dropship/get_mfg_products', {params}).catch(error=>{console.error("Error:", error)})
}

// Get Details: PriceType, Min order values, Min Prepaid value, BuyLines
export const getVendorDetails = (data)=>{
  const params = {vendor_id: data.mfg.vendor_id, fetch_type: data.fetchType || null}
  return axios.get('/api/v1/private/dropship/get_vendor_details', {params}).catch(error=>{console.error("Error:", error)})
}

// Check if user has open dropship cart for browsing vendor
export const cartCheck = (mfg)=>{
  const params = {vendor_id: mfg.vendor_id}
  return axios.post('/api/v1/private/dropship/cart_check', params).catch(error=>{console.error("Error:", error)})
}

export const dropshipAllowed = ()=>{
  const dropshipActive = store.getters.settings.dropship
  return dropshipActive
}

// Build notes based around qualifying for shipment per vendor rules
// Notes to be stamped on 'Internal Notes' in eclipse order header
export const dropshipNoteBuilder = (cart, checkoutForm)=>{
  const cv = initializeCartVendor(cart)
  
  // Build Internal Message
  const setMsg = (cart)=>{
    if(cv.cartTotal){
      if(cv.vendor && cv.vendorMin && cv.vendorPrePaid){
          if(cv.cartTotal >= cv.vendorPrePaid) return "Prepaid Dropship"
          if(cv.cartTotal >= cv.vendorMin) return "Dropship vendor charges freight add freight to customer"
          else return "Contact customer order doesn't meet vendor minimum or prepaid"
      }else{
        return `Missing Vendor Dropship Data, please contact IT (eStore cartID: ${cart.details.id})`
      }
    }else{
      return "No cart total present in eStore cannot determine dropship notes"
    }
  }

  const msg = setMsg(cart)
  
  checkoutForm.form.dropshipInternalNotes = msg
}

export const setShipVia = (cart, checkoutForm)=>{
  const cv = initializeCartVendor(cart)

  // Inject Dropship Ship Vias
  checkoutForm.shipViaOptions = [
    ...checkoutForm.shipViaOptions,
    {text: 'Direct Ship Prepay & Add', value: 'DSA DIRECT PPADD'},
    {text: 'Direct Ship Prepaid', value: 'DSP DIRECT PPD'}
  ]

  // Calc and set ship via
  if(cv.vendor && cv.vendorMin && cv.vendorPrePaid){
    if(cv.cartTotal >= cv.vendorPrePaid){
      checkoutForm.form.shipVia = 'DSP DIRECT PPD'
    }else{
      checkoutForm.form.shipVia = 'DSA DIRECT PPADD'
    }
  }

}

// Return case qty in product sale uom for given product
export const caseQty = (product)=>{
  if(product.eclipse_data){
    const cs = _.find(product.eclipse_data.uoms, {name: 'cs'}) || _.find(product.eclipse_data.uoms, {name: 'ea'})
    return cs.quantity
  }
  return null
}

// Return case count when supplied ea's for given product
export const calcCaseCount = (cartProduct)=>{
  const caseQuantity = caseQty(cartProduct.product_data)
  return cartProduct.quantity / caseQuantity || null
}